export default function PrivacyPage() {
  return (
    <div className="min-h-screen pt-24 pb-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="font-heading text-4xl md:text-5xl font-bold text-primary mb-8">
          Privacy Policy
        </h1>
        
        <div className="prose prose-lg max-w-none text-muted-foreground space-y-6">
          <p className="text-lg">
            <strong>Last Updated:</strong> January 2025
          </p>

          <section>
            <h2 className="font-heading text-2xl font-semibold text-primary mt-8 mb-4">1. Information We Collect</h2>
            <p>
              We collect information you provide directly to us, such as when you create an account, make a booking, 
              subscribe to our newsletter, or contact us. This may include:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Name, email address, and phone number</li>
              <li>Billing and payment information</li>
              <li>Travel preferences and special requests</li>
              <li>Passport and identification details (for bookings)</li>
              <li>Communications with our team</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-semibold text-primary mt-8 mb-4">2. How We Use Your Information</h2>
            <p>We use the information we collect to:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Process and manage your bookings</li>
              <li>Send confirmation emails and travel updates</li>
              <li>Respond to your inquiries and provide customer support</li>
              <li>Send promotional communications (with your consent)</li>
              <li>Improve our services and website experience</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-semibold text-primary mt-8 mb-4">3. Information Sharing</h2>
            <p>
              We may share your information with third parties who assist us in providing our services, including:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Hotels, airlines, and local tour operators (to fulfill your booking)</li>
              <li>Payment processors (to process transactions securely)</li>
              <li>Email service providers (to send communications)</li>
            </ul>
            <p>We do not sell your personal information to third parties.</p>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-semibold text-primary mt-8 mb-4">4. Data Security</h2>
            <p>
              We implement appropriate security measures to protect your personal information. However, no method 
              of transmission over the Internet is 100% secure, and we cannot guarantee absolute security.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-semibold text-primary mt-8 mb-4">5. Your Rights</h2>
            <p>You have the right to:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Access and receive a copy of your personal data</li>
              <li>Request correction of inaccurate information</li>
              <li>Request deletion of your data (subject to legal requirements)</li>
              <li>Opt out of marketing communications</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-semibold text-primary mt-8 mb-4">6. Contact Us</h2>
            <p>
              If you have questions about this Privacy Policy, please contact us at{' '}
              <a href="mailto:info@circulatetravel.com" className="text-secondary hover:underline">
                info@circulatetravel.com
              </a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
